/* Florida Outfitters – product-page helpers (Oct 27, 2026).
   1. Keep the Vitals volume-discount variant dropdowns and the theme's Size/Color swatches in sync.
      - Theme swatch change  -> first-row dropdowns of every Vitals tier follow.
      - Vitals first-row dropdown change -> theme swatches follow.
      Rows 2+ of multi-item tiers stay free so shoppers can still mix sizes/colors.
   2. After Add to Cart, open the slide-out cart drawer so shoppers stay on the product
      (the Vitals offer is set to "Stay on the same page"). */
(function () {
  'use strict';
  var PF = 'form.product-form';
  var RADIO = PF + ' input[type=radio][name^="options["]';
  var syncing = false;

  /* ---------- 2. open the cart drawer after any add-to-cart on this page ---------- */
  var ADD_RE = /\/cart\/add(\.js)?(\?|$)/;
  function openDrawer() {
    try {
      var sc = window.Avatar && Avatar.theme && Avatar.theme.sections && Avatar.theme.sections.SliderCart;
      if (sc && sc.instance && typeof sc.instance.openSliderCart === 'function') { sc.instance.openSliderCart(); return; }
    } catch (e) {}
    var opener = document.querySelector('[data-slider-cart-open]');
    if (opener) opener.click(); else window.location.href = '/cart';
  }
  var openT;
  function afterAdd(ok) {
    if (!ok) return;
    clearTimeout(openT);
    openT = setTimeout(openDrawer, 250);
  }
  function isInternal(init) {
    var h = init && init.headers;
    return !!(h && (h['X-FO-Cart'] || (h.get && h.get('X-FO-Cart'))));
  }
  var prevFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = prevFetch.apply(this, arguments);
    if (ADD_RE.test(url) && !isInternal(init)) p.then(function (r) { afterAdd(r && r.ok); }).catch(function () {});
    return p;
  };
  var xo = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, url) {
    if (ADD_RE.test(String(url))) {
      var x = this;
      x.addEventListener('load', function () { afterAdd(x.status >= 200 && x.status < 300); });
    }
    return xo.apply(this, arguments);
  };

  /* ---------- 1. variant sync ---------- */
  function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
  function optionNames() {
    var out = [];
    document.querySelectorAll(RADIO).forEach(function (r) { if (out.indexOf(r.name) < 0) out.push(r.name); });
    return out;
  }
  function parse(d) {
    var i = d.querySelector('input[type=hidden]');
    var m = i && /VDSelect-(\d+)-(\d+)-option-(\d+)$/.exec(i.name);
    return m ? { tier: +m[1], row: +m[2], opt: +m[3] } : null;
  }
  function firstRowDropdowns() {
    return Array.prototype.filter.call(
      document.querySelectorAll('form.Vtl-NewVolumeDiscountRadio [data-vtl-el="variant-selector"]'),
      function (d) { var p = parse(d); return p && p.row === 0; });
  }
  function sameValue(text, value) {
    text = String(text || '').trim();
    return text === value || text.indexOf(value + ' - ') === 0;
  }
  function setDropdown(d, value) {
    if (d.getAttribute('data-selected-value') === value) return Promise.resolve();
    var h = d.querySelector('.Vtl-Dropdown__Header');
    if (!h) return Promise.resolve();
    h.click();
    return wait(80).then(function () {
      var list = document.getElementById(h.getAttribute('aria-controls') || '');
      var opt = list && Array.prototype.filter.call(list.querySelectorAll('[role=option]'), function (o) { return sameValue(o.textContent, value); })[0];
      if (opt) opt.click();
      return wait(80);
    }).then(function () {
      if (h.getAttribute('aria-expanded') === 'true') h.click();
    });
  }
  function themeToVitals() {
    if (syncing) return;
    var names = optionNames(), ds = firstRowDropdowns();
    if (!names.length || !ds.length) return;
    syncing = true;
    var chain = Promise.resolve();
    ds.forEach(function (d) {
      var n = names[parse(d).opt];
      var r = n && document.querySelector(PF + ' input[type=radio][name="' + n + '"]:checked');
      if (r) chain = chain.then(function () { return setDropdown(d, r.value); });
    });
    chain.then(function () { syncing = false; }, function () { syncing = false; });
  }
  function vitalsToTheme(d) {
    if (syncing) return;
    var p = parse(d);
    if (!p || p.row !== 0) return;
    var n = optionNames()[p.opt];
    if (!n) return;
    var val = d.getAttribute('data-selected-value');
    var r = Array.prototype.filter.call(document.querySelectorAll(PF + ' input[type=radio][name="' + n + '"]'), function (x) { return x.value === val; })[0];
    if (!r || r.checked) return;
    var lab = document.querySelector('label[for="' + r.id + '"]');
    syncing = true;
    (lab || r).click();
    setTimeout(function () { syncing = false; themeToVitals(); }, 200);
  }

  function init() {
    if (!document.querySelector(RADIO)) return;
    document.addEventListener('change', function (e) {
      if (e.target.matches && e.target.matches(RADIO)) setTimeout(themeToVitals, 80);
    });
    var addT;
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        if (m.type === 'attributes') {
          if (m.target.closest && m.target.closest('form.Vtl-NewVolumeDiscountRadio')) vitalsToTheme(m.target);
        } else if (m.addedNodes.length) {
          clearTimeout(addT);
          addT = setTimeout(themeToVitals, 150);
        }
      });
    }).observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['data-selected-value'] });
    themeToVitals();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
